exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".frame-preview[data-v-0f3fe294] svg,.frame-preview[data-v-0f3fe294] div{width:100%;height:100%}\n", ""]);

